export const roundToOneDecimal = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return 0;
  }
  return Math.round((numericValue + Number.EPSILON) * 10) / 10;
};

export const formatHours = (value) => {
  const rounded = roundToOneDecimal(value);
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};
